// User standard structure

export class User {

	_id: string;
	// Full name
	name: string;

	// credential fields
	email: string;
	password: string;

	print_with_header: boolean;
	print_with_footer: boolean;
	print_zero_accounts: boolean;

	minimizedSidebar: boolean;

	// linked details
	details: any;

	authorization_level: number;
}



// WEBPACK FOOTER //
// ./src/app/authentication/user.ts